import { render, staticRenderFns } from "./ChooseStoreOrder.vue?vue&type=template&id=b2b2b324&scoped=true"
import script from "./ChooseStoreOrder.vue?vue&type=script&lang=js"
export * from "./ChooseStoreOrder.vue?vue&type=script&lang=js"
import style0 from "./ChooseStoreOrder.vue?vue&type=style&index=0&id=b2b2b324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b2b324",
  null
  
)

export default component.exports